import {
  DataUploadSteps,
  ModaUploadSteps,
  ExcelMappingSteps,
  IStep,
  IStepData,
  ISubStep,
  MappingSteps,
} from "../interfaces/markets"

import DataExcel from "../components/Markets/ExcelDataUpload/DataExcel"
import MappingSettings from "../components/Markets/ExcelDataUpload/Mapping/MappingSettings"
import MappingHeader from "../components/Markets/ExcelDataUpload/Mapping/MappingHeader"
import MappingStepWrapper from "../components/Markets/ExcelDataUpload/Mapping/MappingStepWrapper"
import MappingFields from "../components/Markets/ExcelDataUpload/Mapping/MappingFields"
import MappingValidation from "../components/Markets/ExcelDataUpload/Mapping/MappingValidation"
import MappingGlobalFields from "../components/Markets/ExcelDataUpload/Mapping/MappingGlobalFields"
import Validation from "../components/Markets/ExcelDataUpload/Validation/Validation"

import Finalize from "../components/Markets/ExcelDataUpload/Finalize/Finalize"
import ModaConfig from "../components/Markets/ModaMapping/ModaConfig"
import UploadXlsFile from "../components/Markets/ModaMapping/UploadXlsFile"
import ModaFieldMapping from "../components/Markets/ModaMapping/ModaFieldMapping"
import GlobalFieldMapping from "../components/Markets/ModaMapping/GlobalFieldMapping"
import ModaFinalize from "../components/Markets/ModaMapping/ModaFinalize"

export const mappingSteps: ISubStep[] = [
  {
    id: MappingSteps.HEADER,
    label: "Header",
    content: <MappingHeader />,
    description: "Define header row",
    isVisible: (data: IStepData) => data.showNewMapping,
  },
  {
    id: MappingSteps.FIELDS,
    label: "Fields Mapping",
    description: "Map fields to columns",
    isVisible: (data: IStepData) => data.showNewMapping,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <MappingFields />
        <MappingValidation />
      </div>
    ),
  },
  {
    id: MappingSteps.GLOBAL,
    label: "Global Options",
    description: "Define global fields",
    isVisible: (data: IStepData) => data.showNewMapping,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <MappingGlobalFields />
        <MappingValidation />
      </div>
    ),
  },
]

export const modaMappingSteps: ISubStep[] = [
  {
    id: MappingSteps.HEADER,
    label: "Excel upload",
    description: "Upload Excel file",
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <UploadXlsFile />
      </div>
    ),
  },
  {
    id: MappingSteps.FIELDS,
    label: "Fields Mapping",
    description: "Map fields",
    showMappedField: true,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <ModaFieldMapping />
      </div>
    ),
  },
  {
    id: MappingSteps.GLOBAL,
    label: "Global Options",
    description: "Define global fields",
    showMappedField: true,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <GlobalFieldMapping />
      </div>
    ),
  },
]

export const steps: IStep[] = [
  {
    id: DataUploadSteps.DATA,
    label: "Upload Data",
    content: <DataExcel />,
    description: "Add your Excel file to begin",
    nextAction: "Continue",
  },
  {
    id: DataUploadSteps.MAPPING,
    label: "Map Columns",
    description: "Match Excel columns to system fields",
    content: <MappingSettings />,
    wrapper: MappingStepWrapper,
    substeps: [...mappingSteps],
    nextAction: "Continue",
  },
  {
    id: DataUploadSteps.VALIDATION,
    label: "Validate Data",
    content: <Validation />,
    description: "Check and confirm uploaded data",
    nextAction: "Confirm & Finalize",
  },
  {
    id: DataUploadSteps.FINALIZE,
    label: "Finalize Submission",
    content: <Finalize />,
    description: "Submit for review and approval",
    nextAction: "Save",
  },
]

export const excelMappingSteps = [
  {
    id: ExcelMappingSteps.DATA,
    label: "Data",
    content: <DataExcel withMappingName />,
    description: "Upload Excel",
  },
  ...mappingSteps.map(item => ({ ...item, id: item.id + 1 })),
]

export const modaSteps: IStep[] = [
  {
    id: ModaUploadSteps.CONFIG,
    label: "Connection Setup",
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <ModaConfig />
      </div>
    ),
    description: "Set up and test the connection to MODA",
    nextAction: "Continue",
  },
  {
    id: ModaUploadSteps.CONNECT,
    label: "XLSForm Mapping",
    content: <div>SubStep</div>,
    description: "Set up and test the connection to MODA",
    nextAction: "Continue",
    substeps: [...modaMappingSteps],
  },
  {
    id: ModaUploadSteps.FINALIZE,
    label: "Finalize",
    content: <ModaFinalize />,
    description: "Save settings and start data fetch",
    nextAction: "Go to Dashboard",
  },
]

export const modaEditSteps: IStep[] = [
  {
    id: MappingSteps.HEADER,
    label: "Connection Setup",
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <span>Not allowed on edit</span>
      </div>
    ),
    description: "Set up and test the connection to MODA",
    nextAction: "Continue",
  },
  {
    id: MappingSteps.FIELDS,
    label: "XLSForm Mapping",
    description: "Match XLSForm fields to system fields",
    showMappedField: true,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <ModaFieldMapping />
      </div>
    ),
  },
  {
    id: MappingSteps.GLOBAL,
    label: "Global Options",
    description: "Define global fields",
    showMappedField: true,
    content: (
      <div className="grid grid-rows-[1fr_auto] min-h-[calc(100vh-350px)]">
        <GlobalFieldMapping />
      </div>
    ),
  },
  {
    id: 4,
    label: "Save Update",
    content: <ModaFinalize />,
    description: "Update Mapping Schema",
    nextAction: "Go to Dashboard",
  },
]

export const modaValidationSteps = [
  {
    id: DataUploadSteps.VALIDATION,
    label: "Validate Data",
    content: <Validation />,
    description: "Review and validate data",
    nextAction: "Confirm & Finalize",
  },
  {
    id: DataUploadSteps.FINALIZE,
    label: "Finalize",
    content: <Finalize />,
    description: "Submit for approval",
    nextAction: "Save",
  },
]

export enum FetchStatus {
  SUCCESS = 1,
  ERROR = 2,
  WARNING = 3,
}

export const ContentType = {
  moda: {
    text: "Connect to MODA",
    path: "/market-prices/moda-data-upload",
  },
  excel: {
    text: "Upload Excel File",
    path: "/market-prices/data-upload",
  },
}

export const MappingType = {
  moda: {
    text: "Connect to MODA",
    path: "/market-prices/moda-data-upload",
  },
  excel: {
    text: "New Mapping Schema",
    path: "/market-prices/mappingschema/add",
  },
}
